/**
 * TenantConfig — per-entity конфигурация (валюта, fiscal year, onboarding date).
 * Auto-created при insert entities (BM-3-9), updatable через BM-3-15 endpoint.
 */
import { z } from 'zod';
import { IsoDateTime, UuidString } from '../primitives.js';
import { EntityCurrency } from './entity.js';

export const TenantConfig = z.object({
  entity_id: UuidString,
  default_currency: EntityCurrency,
  fiscal_year_start_month: z.number().int().min(1).max(12),
  /** Onboarding date — единственный SLE `Opening Stock` день для entity (можно set один раз). */
  onboarding_date: z.string().nullable(),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type TenantConfig = z.infer<typeof TenantConfig>;

/** Partial update (BM-3-15). Все три поля optional. */
export const TenantConfigPatch = z
  .object({
    default_currency: EntityCurrency.optional(),
    fiscal_year_start_month: z.number().int().min(1).max(12).optional(),
    onboarding_date: z.string().date().nullable().optional(),
  })
  // zod-strict-ok: input request-body
  .strict();
export type TenantConfigPatch = z.infer<typeof TenantConfigPatch>;
